//
// Group box-like select/option widget with title.
//
import { useState } from 'react';

import gUtilities from '../script/utilities';

//
// props:
//   string    title      - header
//   array     items      - option value strings
//   string    width      - one of { small, medium, large, 'Npx' }
//   function  onSelect   - function (index) -> void (argument is index to selected item)
//
const SelectWidget = (props) => {
    const [isSelected, setIsSelected] = useState(false);
    const [widgetID] = useState(gUtilities.widgetID());

    function onSelect(evt) {
        if (evt && evt.target) {
            if (evt.target.value === "Select") {
                return;
            }

            let index;
            if (isSelected) {
                index = evt.target.selectedIndex;
            } else {
                index = evt.target.selectedIndex - 1;
            }

            setIsSelected(true);
            props.onSelect(index);
        }
    }

    function selectStyle() {
        let px = "200px";

        if (props.hasOwnProperty("width")) {
            if (props.width === "small") {
                px = "120px";
            } else if (props.width === "large") {
                px = "300px";
            } else {
                px = props.width;
            }
        }
        
        let style = {
            width: px
        };

        return style;
    }

    return (
        <div className="form-group">
            <label className="col-form-label mt-1" htmlFor={widgetID}>{props.title}</label>
            <div className="input-group mb-1">
                <select className="form-select" id={widgetID}  onChange={onSelect} style={selectStyle()}>
                    { !isSelected &&
                        <option>Select</option>
                    }
                    {
                        props.items.map((item) => (
                            <option>{item}</option>
                        ))
                    }
                </select>
            </div>
        </div>
    );
}

export default SelectWidget;